export default "__VITE_ASSET__DHCJdmAc__"